import { SxProps } from '@mui/material';

export const CardLinkFrameSx: SxProps = {
	border: '1px solid #C9C9C9',
	height: '120px',
	minWidth: '170px',
	maxWidth: '170px',
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	justifyContent: 'center',
	alignItems: 'center',
	borderRadius: 1.5,
	'&:hover': {
		backgroundColor: '#F5F0FF',
		border: '2px solid #774A91',
		'& svg': {
			fill: '#774A91',
		},
		'#shipping-deliveries-svg': {
			stroke: '#774A91',
		},
		'#returns-svg': {
			stroke: '#774A91',
		},
		'& p': {
			color: '#774A91',
		},
	},
	'&:active': {
		backgroundColor: '#F5F0FF',
		border: '2px solid #774A91',
		'& svg': {
			fill: '#774A91',
		},
		'#shipping-deliveries-svg': {
			stroke: '#774A91',
		},
		'#returns-svg': {
			stroke: '#774A91',
		},
		'& p': {
			color: '#774A91',
		},
	},
};

export const CardLinkNameSx: SxProps = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
};
